import { create } from "zustand";
import { addEdge, applyNodeChanges, applyEdgeChanges } from "@xyflow/react";

const useStore = create((set, get) => ({
  nodes: [],
  edges: [],
  onNodesChange: (changes) => {
    set({
      nodes: applyNodeChanges(changes, get().nodes),
    });
  },
  onEdgesChange: (changes) => {
    set({
      edges: applyEdgeChanges(changes, get().edges),
    });
  },
  onConnect: (connection) => {
    // sourceHandle只能连一条线，后连的线会覆盖先连的线
    const fliter = get().edges.filter((obj) =>
      obj?.sourceHandle
        ? !(
            obj.source === connection.source &&
            obj?.sourceHandle === connection?.sourceHandle
          )
        : obj.source !== connection.source
    );
    set({
      edges: addEdge(connection, fliter),
    });
  },
  setNodes: (nodes) => {
    set({ nodes });
  },
  agentSetting: {
    id: "1",
    title: "",
    lang: "en",
    voice: "",
  },
  setAgent: (agent) => {
    set({ agentSetting: { ...get().agentSetting, ...agent } });
  },
  setEdges: (edges) => {
    set({ edges });
  },
}));

export default useStore;
